import { Middleware } from 'redux';
import { navigateTo } from '../case/actions';

const navigationMiddleware: Middleware = () => (next) => (action) => {
  if (navigateTo.match(action)) {
    // Handle navigation state, React Router will process it in components
  }
  return next(action);
};

export { navigationMiddleware };
